// removed by extract-text-webpack-plugin
module.exports = {"container":"_2oOoIUVTm-vMea0H0KXIoX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contentContainer/contentContainer.css
// module id = 1543
// module chunks = 0